import { TFunction } from 'i18next';
import { ValidationError } from 'components/ui/excel-table/types';
import { isNil } from 'lodash';
import { FirePricingAnalysisRow } from './types';

export const validateFirePricingAnalysisRow = (
  row: FirePricingAnalysisRow,
  rowIndex: number,
  t: TFunction
): ValidationError<FirePricingAnalysisRow>[] => {
  const errors: ValidationError<FirePricingAnalysisRow>[] = [];
  if (isNil(row.fireMultiplier) || row.fireMultiplier < 0) {
    errors.push({
      field: 'fireMultiplier',
      rowIndex,
      message: t('firePricingAnalysis.validation.multiplierInvalid'),
    });
  }

  if (isNil(row.biRate) || row.biRate < 0 || row.biRate > 100) {
    errors.push({
      field: 'biRate',
      rowIndex,
      message: t('firePricingAnalysis.validation.biRateInvalid'),
    });
  }

  if (isNil(row.pdRate) || row.pdRate < 0 || row.pdRate > 100) {
    errors.push({
      field: 'pdRate',
      rowIndex,
      message: t('firePricingAnalysis.validation.pdRateInvalid'),
    });
  }

  return errors;
};
